import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // 引入 useNavigate hook
import {
  EuiPanel, EuiIcon, EuiFlexGroup, EuiFlexItem, EuiButton, EuiSelect, EuiButtonIcon,
  EuiListGroup, EuiListGroupItem, EuiModal, EuiModalHeader, EuiModalBody, EuiModalFooter,
  EuiFieldText, EuiTextArea, EuiDragDropContext, EuiDroppable, EuiDraggable,
  EuiButtonEmpty, copyToClipboard, EuiSwitch, EuiHeader, EuiHeaderSection, EuiHeaderSectionItem,
  euiDragDropReorder,EuiText, EuiSpacer
} from '@elastic/eui';
import { TranslateLanguage } from './KeywordTranslator';
import '../style.css';
import logosmall from '../assets/CTBLogoCircle-Small.png';
import RadioModal from "../components/RadioModal";
import PlaylistModal from "../components/PlaylistModal";
import YouTubePlaylistImport from './YouTubePlaylistImport';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useAlert } from './AlertProvider';
import TopRightMenu from "../components/TopRightMenu";
import LanguageToggle from "../components/LanguageToggle";
import { Capacitor } from '@capacitor/core';
import { keepScreenAwakeForPlayback, releaseScreenAwakeForPlayback } from './nativePlaybackBridge';

// =====================
// ✅ 新增：歌单排序工具函数（置顶/上移/下移）
// =====================
const splitPlaylists = (list) => {
  const pinned = (list || []).filter(p => !!p.pinned);
  const normal = (list || []).filter(p => !p.pinned);
  return { pinned, normal };
};

const mergePlaylists = (pinned, normal) => [...(pinned || []), ...(normal || [])];

const moveWithinGroup = (group, id, direction) => {
  const idx = group.findIndex(p => p.id === id);
  if (idx < 0) return group;
  const next = idx + direction;
  if (next < 0 || next >= group.length) return group;

  const copy = [...group];
  const [item] = copy.splice(idx, 1);
  copy.splice(next, 0, item);
  return copy;
};

// 置顶/取消置顶：默认放到目标分组的末尾（你也可以改成顶部）
const togglePinned = (list, id) => {
  const { pinned, normal } = splitPlaylists(list);
  const inPinned = pinned.some(p => p.id === id);

  if (inPinned) {
    const target = pinned.find(p => p.id === id);
    const newPinned = pinned.filter(p => p.id !== id);
    const newNormal = [...normal, { ...target, pinned: false }];
    return mergePlaylists(newPinned, newNormal);
  } else {
    const target = normal.find(p => p.id === id);
    const newNormal = normal.filter(p => p.id !== id);
    const newPinned = [...pinned, { ...target, pinned: true }];
    return mergePlaylists(newPinned, newNormal);
  }
};

function PlaylistPageWithPlayer() {
  const [playlists, setPlaylists] = useState([]);
  const [playlistSongCounts, setPlaylistSongCounts] = useState({});
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const [currentPlaylistName, setCurrentPlaylistName] = useState('');
  const [songs, setSongs] = useState([]);
  const [currentSong, setCurrentSong] = useState({ id: '', name: '' });
  const [initSong, setInitSong] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [newPlaylistName, setNewPlaylistName] = useState('');
  const [newSongName, setNewSongName] = useState('');
  const [newSongLink, setNewSongLink] = useState('');
  const [isPanelVisible, setIsPanelVisible] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showAddSongModal, setShowAddSongModal] = useState(false);
  const [addSongMode, setAddSongMode] = useState('single');
  const [showCreateRadioModal, setShowCreateRadioModal] = useState(false);
  const [showPlaylistToRadioModal, setshowPlaylistToRadioModal] = useState(false);
  const [newPlaylistVisibility, setNewPlaylistVisibility] = useState('private');
  const [newPlaylistDescription, setNewPlaylistDescription] = useState('');
  const [newPlaylistTags, setNewPlaylistTags] = useState('');
  const [newPlaylistCategory, setNewPlaylistCategory] = useState('');
  const [expandedPlaylist, setExpandedPlaylist] = useState(null);
  const [playlistDetails, setPlaylistDetails] = useState(null);
  const [shareLink, setShareLink] = useState("");
  const navigate = useNavigate();
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const playerRef = useRef(null);
  const [ytApiReady, setYtApiReady] = useState(false);
  const currentSongRef = useRef(currentSong);
  const songsRef = useRef(songs);
  const [showHint, setShowHint] = useState(true);
  const songtitleRef = useRef(null);
  const leftpanelRef = useRef(null);
  const playerShellRef = useRef(null);
  const [isPlayerFullscreen, setIsPlayerFullscreen] = useState(false);
  const showAlert = useAlert();
  const [isLoopEnabled, setIsLoopEnabled] = useState(true);
  const isLoopEnabledRef = useRef(isLoopEnabled);
  const [showPlaylistModal, setShowModal] = useState(false);
  const [modalProps, setModalProps] = useState({
    userId: '',
    playlistId: '',
    playlisttype: ''
  });
  const [playlistmodalProps, setPlaylistModalProps] = useState({
    userId: '',
    songId: '',
    videoURL: '',
    type: '',
    engineId: '',
    title: '',
    label: '',
    playlisttype: '',
    closeModal: () => { },
    onSaveSuccess: () => { }
  });
  const [isLoadingPlaylists, setIsLoadingPlaylists] = useState(true);
  const [isLoadingSongs, setIsLoadingSongs] = useState(true);

  // =====================
  // ✅ 新增：排序模式
  // =====================
  const [isSortMode, setIsSortMode] = useState(false);
  const [isSavingPlaylistOrder, setIsSavingPlaylistOrder] = useState(false);

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroidApp =  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

  // 从 sessionStorage 获取 userId
  const user = JSON.parse(sessionStorage.getItem('user'));
  const userId = user ? user.id : null;
  const token = sessionStorage.getItem("token");

  const hasPlaylists = Array.isArray(playlists) && playlists.length > 0;
  const hasSongs = Array.isArray(songs) && songs.length > 0;
  const showEmpty = !isLoadingPlaylists && !isLoadingSongs && (!hasPlaylists || !hasSongs);
  const shouldShowPlayer = !showEmpty && songs?.length > 0 && !!currentSong;

  const syncPlaylistSongCount = (playlistId, count) => {
    const normalizedCount = Number.isFinite(Number(count)) ? Number(count) : 0;
    setPlaylistSongCounts(previousCounts => {
      if (previousCounts[playlistId] === normalizedCount) return previousCounts;
      return { ...previousCounts, [playlistId]: normalizedCount };
    });
  };

  let userRole = "";
  if (token) {
    const decodedToken = jwtDecode(token);
    userRole = decodedToken.role;
  }

  const destroyPlayer = () => {
    try {
      playerRef.current?.destroy?.();
    } catch { }
    playerRef.current = null;
  };

  useEffect(() => {
    if (!ytApiReady) return;

    if (initSong) {
      if (playerRef.current) {
        try {
          playerRef.current.loadVideoById(initSong.resourceId);
          if (isIOS) playerRef.current.unMute();
        } catch { }
        return;
      }

      const el = document.getElementById('youtube-player');
      if (!el) return;

      playerRef.current = new YT.Player(el, {
        height: '80%',
        width: '90%',
        videoId: initSong.resourceId,
        playerVars: {
          autoplay: isIOS ? 0 : 1,
          controls: 1,
          mute: isIOS ? 1 : 0,
        },
        events: {
          onStateChange: onPlayerStateChange,
          onError: onPlayerError,
        },
      });
    } else {
      destroyPlayer();
    }
    return () => destroyPlayer();
  }, [ytApiReady, initSong]);

  useEffect(() => {
    if (playerRef.current && currentSong?.resourceId) {
      try {
        playerRef.current.loadVideoById(currentSong.resourceId);
        if (isIOS) playerRef.current.unMute();
      } catch { }
    }
  }, [currentSong?.resourceId]);

  useEffect(() => {
    if (isIOS) setShowHint(true);
    else setShowHint(false);

    const script = document.createElement('script');
    script.src = "https://www.youtube.com/iframe_api";
    script.async = true;
    script.onload = () => {
      if (window.YT && window.YT.Player) {
        setYtApiReady(true);
      }
    };
    document.body.appendChild(script);

    window.onYouTubeIframeAPIReady = () => {
      setYtApiReady(true);
    };

    setTimeout(() => {
      if (window.YT && window.YT.Player && !ytApiReady) {
        setYtApiReady(true);
      }
    }, 5000);
  }, []);

  // 同步更新 currentSongRef
  useEffect(() => {
    currentSongRef.current = currentSong;
  }, [currentSong]);

  useEffect(() => {
    songsRef.current = songs;
  }, [songs]);

  const SongItem = ({ song, currentSong, handleSongClick, handleDeleteSong, handleMoveSong }) => {
    const songItemRef = useRef(null);

    useEffect(() => {
      if (songItemRef.current && currentSong && currentSong.resourceId === song.resourceId) {
        songItemRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, [currentSong, song]);

    return (
      <div ref={songItemRef}>
        <EuiPanel
          hasShadow={false}
          paddingSize="none"
          color={currentSong.resourceId === song.resourceId ? "danger" : "none"}
          hasBorder={true}
        >
          <EuiFlexGroup wrap={false} alignItems="center" gutterSize="s" style={{ flexWrap: 'nowrap' }}>
            <EuiFlexItem grow={false} style={{ flexShrink: 0, flexBasis: '20px', minWidth: '20px', maxWidth: '20px' }}>
              <EuiIcon type="grab" />
            </EuiFlexItem>
            <EuiFlexItem grow={true} style={{ flexShrink: 1, flexBasis: '100%' }}>
              <EuiListGroupItem
                className={`song-item ${currentSong && currentSong.resourceId === song.resourceId ? 'playing-song' : ''}`}
                style={{ zIndex: 1 }}
                label={
                  <>
                    {isPortrait
                      ? TranslateLanguage(localStorage.userLanguage, song.name)
                      : (song.name.length > 12
                        ? TranslateLanguage(localStorage.userLanguage, song.name.substring(0, 12)) + '...'
                        : TranslateLanguage(localStorage.userLanguage, song.name))}
                  </>
                }
                icon={
                  <>
                    <EuiIcon
                      type="cross"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteSong(song);
                      }}
                      style={{ marginLeft: '0px', marginRight: '10px', cursor: 'pointer' }}
                    />
                    <EuiIcon
                      type="popout"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMoveSong(song);
                      }}
                      style={{ marginLeft: '0px', marginRight: '10px', cursor: 'pointer' }}
                    />
                  </>
                }
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  e.currentTarget.focus();
                  handleSongClick(song);
                }}
              />
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiPanel>
      </div>
    );
  };

  // function setViewportDimensions() {
  //   let height = 44;
  //   let calwidth;
  //   let calheight;
  //   calwidth = window.innerWidth - 30;
  //   calheight = window.innerHeight - height;
  //   if (calwidth * 9 / 16 > calheight)
  //     document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight - height}px`);
  //   else
  //     document.documentElement.style.setProperty('--viewport-height', `${calwidth * 9 / 16}px`);
  //   document.documentElement.style.setProperty('--viewport-width', `${window.innerWidth - 20}px`);
  // }

  // setViewportDimensions();
  // window.addEventListener('resize', setViewportDimensions);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsPortrait(window.innerHeight > window.innerWidth);
  //   };

  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  useEffect(() => {
  const updateViewportDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const reservedHeight = 44;

    const availableWidth = Math.max(0, width - 30);
    const availableHeight = Math.max(
      0,
      height - reservedHeight
    );

    const playerHeight = Math.min(
      availableWidth * 9 / 16,
      availableHeight
    );

    document.documentElement.style.setProperty(
      '--viewport-height',
      `${playerHeight}px`
    );

    document.documentElement.style.setProperty(
      '--viewport-width',
      `${Math.max(0, width - 20)}px`
    );

    // 不要用键盘改变后的可见高度判断横竖屏
    setIsPortrait(
      window.matchMedia('(orientation: portrait)').matches
    );
  };

  updateViewportDimensions();

  window.addEventListener(
    'resize',
    updateViewportDimensions
  );

  return () => {
    window.removeEventListener(
      'resize',
      updateViewportDimensions
    );
  };
}, []);

  const onPlayerStateChange = (event) => {
    switch (event.data) {
      case YT.PlayerState.PLAYING:
        keepScreenAwakeForPlayback();
        if (isIOS) {
          playerRef.current.unMute();
        }
        break;
      case YT.PlayerState.PAUSED:
        releaseScreenAwakeForPlayback();
        break;
      case YT.PlayerState.ENDED:
        releaseScreenAwakeForPlayback();
        handleSongEnd();
        break;
      default:
        break;
    }
  };

  function onPlayerError(event) {
    const errorCode = event.data;
    switch (errorCode) {
      case 2:
        showAlert(TranslateLanguage(localStorage.userLanguage, "視頻ID無效，請檢查視頻ID。"));
        break;
      case 5:
        showAlert(TranslateLanguage(localStorage.userLanguage, "視頻無法播放，可能是格式問題。"));
        break;
      case 100:
        showAlert(TranslateLanguage(localStorage.userLanguage, "視頻已被刪除或設為私人視頻。"));
        break;
      case 101:
      case 150:
        showAlert(TranslateLanguage(localStorage.userLanguage, "視頻不允許嵌入播放。"));
        break;
      default:
        showAlert(TranslateLanguage(localStorage.userLanguage, "視頻播放出錯，請嘗試其他視頻。"));
        break;
    }
  }

  // =====================
  // ✅ 获取歌单：增加默认排序（pinned desc, orderIndex asc）
  // =====================
  useEffect(() => {
    setIsLoadingPlaylists(true);
    axios.get(`/api/playlists`, {
      params: {
        userId: userId,
        type: 'song',
      },
    })
      .then(response => {
        const data = response.data || [];
        // 如果后端还没返回 pinned/orderIndex，这里兜底为 false / 0，避免前端崩
        const normalized = data.map(p => ({
          ...p,
          pinned: !!p.pinned,
          orderIndex: Number.isFinite(p.orderIndex) ? p.orderIndex : 0,
          songCount: Number.isFinite(Number(p.songCount)) ? Number(p.songCount) : 0,
        }))
          .sort((a, b) => {
            if ((!!b.pinned) !== (!!a.pinned)) return (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0);
            const ao = Number.isFinite(a.orderIndex) ? a.orderIndex : 0;
            const bo = Number.isFinite(b.orderIndex) ? b.orderIndex : 0;
            if (ao !== bo) return ao - bo;
            return String(a.id).localeCompare(String(b.id));
          });

        setPlaylists(normalized);
        setPlaylistSongCounts(Object.fromEntries(
          normalized.map(playlist => [playlist.id, playlist.songCount])
        ));
        setIsLoadingPlaylists(false);
      })
      .catch(error => {
        console.error('Error fetching playlists:', error);
        setIsLoadingPlaylists(false);
      });
  }, []);

  const handlePlaylistChange = (playlistId) => {
    // ✅ 排序模式下禁用展开/选择，避免误触
    if (isSortMode) return;

    if (expandedPlaylist === playlistId) {
      setExpandedPlaylist(null);
      return;
    }

    // 再次展開目前歌單時沿用現有歌曲與播放狀態，不重新從第一首開始。
    if (selectedPlaylist === playlistId) {
      setExpandedPlaylist(playlistId);
      return;
    }

    setIsLoadingSongs(true);
    setSelectedPlaylist(playlistId);
    const targetPlaylist = playlists.find((playlist) => playlist.id === playlistId);
    setCurrentPlaylistName(targetPlaylist?.name || '');

    axios.get(`/api/playlists/${playlistId}/songs`)
      .then(response => {
        const sortedSongs = (response.data || []).sort((a, b) => a.order - b.order);
        setSongs(sortedSongs);
        setInitSong(sortedSongs[0]);
        syncPlaylistSongCount(playlistId, sortedSongs.length);
        setExpandedPlaylist(playlistId);
        setIsLoadingSongs(false);
      })
      .catch(error => {
        console.error('Error fetching songs:', error);
        setIsLoadingSongs(false);
      });
  };

  //删除歌曲
  const handleDeleteSong = (songId) => {
    if (window.confirm(TranslateLanguage(localStorage.userLanguage, "確定從歌單中刪除這首詩歌？"))) {
      axios.delete(`/api/playlists/${selectedPlaylist}/songs/${songId.resourceId}`)
        .then(response => {
          if (response.status === 200) {
            const updatedSongs = songs.filter(song => song.resourceId !== songId.resourceId);
            setSongs(updatedSongs);
            syncPlaylistSongCount(selectedPlaylist, updatedSongs.length);
            showAlert(TranslateLanguage(localStorage.userLanguage, "刪除成功"));
          } else {
            showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
          }
        })
        .catch(error => {
          console.error("删除歌曲时出错:", error);
          showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
        });
    }
  };

  //移動歌曲
  const handleMoveSong = (songcur) => {
    const user = sessionStorage.getItem('user');
    const handleSaveSuccess = () => {
      if (window.confirm(TranslateLanguage(localStorage.userLanguage, '移動歌曲成功，是否從原歌單中刪除這首詩歌？'))) {
        axios
          .delete(`/api/playlists/${selectedPlaylist}/songs/${songcur.resourceId}`)
          .then((response) => {
            if (response.status === 200) {
              const updatedSongs = songs.filter((song) => song.resourceId !== songcur.resourceId);
              setSongs(updatedSongs);
              syncPlaylistSongCount(selectedPlaylist, updatedSongs.length);
              showAlert(TranslateLanguage(localStorage.userLanguage, '刪除成功'));
            } else {
              showAlert(TranslateLanguage(localStorage.userLanguage, '刪除失敗，請重試'));
            }
          })
          .catch((error) => {
            console.error('删除歌曲时出错:', error);
            showAlert(TranslateLanguage(localStorage.userLanguage, '刪除失敗，請重試'));
          });
      }
    };
    setPlaylistModalProps({
      userId: JSON.parse(user).id,
      songId: songcur.id,
      videoURL: songcur.link,
      type: '詩歌',
      engineId: songcur.engineID,
      title: songcur.name,
      label: 'v',
      playlisttype: 'song',
      closeModal: () => setShowModal(false),
      onSaveSuccess: () => handleSaveSuccess()
    });
    setShowModal(true);
  };

  // playlists 加载完成后自动选第一个
  useEffect(() => {
    if (playlists.length > 0) {
      handlePlaylistChange(playlists[0].id);
    }
    else {
      setSelectedPlaylist(null);
    }
  }, [playlists]);

  // 歌曲列表更新后自动播放第一首
  useEffect(() => {
    if (songs.length > 0) {
      setCurrentSong(songs[0]);
    }
  }, [songs]);

  useEffect(() => {
    const player = document.getElementById('youtube-player');
    if (player) {
      player.className = isPanelVisible ? 'playlist-player' : 'playlist-player-full';
    }
  }, [isPanelVisible]);

  const handleSongClick = (song) => {
    if (currentSong === song) {
      if (playerRef.current.getPlayerState() === 0) {
        playerRef.current.seekTo(0);
        setTimeout(() => playerRef.current.playVideo(), 10);
      }
      else if (playerRef.current.getPlayerState() === 2) {
        playerRef.current.playVideo();
      }
    } else {
      setCurrentSong(song);
    }
  };

  const handleEditClick = () => {
    if (selectedPlaylist) {
      axios.get(`/api/playlists/${selectedPlaylist}`)
        .then(response => {
          const data = response.data;
          setPlaylistDetails(data);
          setNewPlaylistName(data.name);
          setNewPlaylistVisibility(data.visibility);
          setNewPlaylistDescription(data.description);
          setNewPlaylistTags(data.tags);
          setNewPlaylistCategory(data.category);
          setIsEditModalVisible(true);
        })
        .catch(error => {
          console.error('Error fetching playlist details:', error);
        });
    }
  };

  // 播放结束自动下一首
  const handleSongEnd = () => {
    const currentIndex = songsRef.current.findIndex(song => song.resourceId === currentSongRef.current?.resourceId);
    if (currentIndex === -1) return;

    if (isLoopEnabledRef.current) {
      if (currentIndex < songsRef.current.length - 1) {
        const nextIndex = currentIndex + 1;
        setCurrentSong(songsRef.current[nextIndex]);
      } else {
        playerRef.current.pauseVideo();
      }
    } else {
      playerRef.current.pauseVideo();
    }
  };

  //保存修改後的歌單信息
  const handleSaveChanges = () => {
    const requestBody = {
      name: newPlaylistName,
      visibility: newPlaylistVisibility,
      description: newPlaylistDescription,
      tags: newPlaylistTags,
      category: newPlaylistCategory
    };
    axios.put(`/api/playlists/${selectedPlaylist}`, requestBody, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(() => {
        setIsEditModalVisible(false);
        const updatedPlaylists = playlists.map(p => p.id === selectedPlaylist ? { ...p, ...requestBody } : p);
        setPlaylists(updatedPlaylists);
      })
      .catch(error => {
        console.error('Error updating playlist:', error);
      });
  };

  // 打开新建歌单模态窗口
  const openCreatePlaylistModal = () => {
    setNewPlaylistName("");
    setNewPlaylistDescription("");
    setNewPlaylistTags("");
    setNewPlaylistCategory("");
    setShowCreateModal(true);
  };

  const openCreateRadioModal = () => {
    setShowCreateRadioModal(true);
  };

  const openAddSongModal = () => {
    setNewSongName("");
    setNewSongLink("");
    setAddSongMode('single');
    setShowAddSongModal(true);
  };

  const closeAddSongModal = () => setShowAddSongModal(false);
  const closeCreatePlaylistModal = () => setShowCreateModal(false);
  const closeCreateRadioModal = () => setShowCreateRadioModal(false);

  // 创建新歌单
  const handleCreatePlaylist = () => {
    const requestBody = {
      userId: user.id,
      name: newPlaylistName,
      type: 'song',
      visibility: newPlaylistVisibility,
      description: newPlaylistDescription,
      tags: newPlaylistTags,
      category: newPlaylistCategory
    };

    axios.post(`/api/playlists/create`, requestBody, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        const data = response.data;
        showAlert(TranslateLanguage(localStorage.userLanguage, "歌單創建成功"));
        closeCreatePlaylistModal();

        // ✅ 新增歌单：默认追加到普通分组末尾
        setPlaylists(prev => ([
          ...prev,
          { id: data.playlistId, name: newPlaylistName, pinned: false, orderIndex: prev.length, songCount: 0 }
        ]));
        syncPlaylistSongCount(data.playlistId, 0);
      })
      .catch(error => {
        console.error('Error creating playlist:', error);
      });
  };

  // 创建新電臺
  const handleCreateRadio = () => {
    const requestBody = {
      userId: user.id,
      name: newPlaylistName,
      type: 'radio',
      visibility: newPlaylistVisibility,
      description: newPlaylistDescription,
      tags: newPlaylistTags,
      category: newPlaylistCategory
    };
    axios.post(`/api/playlists/create`, requestBody, { headers: { 'Content-Type': 'application/json' } })
      .then(() => {
        showAlert(TranslateLanguage(localStorage.userLanguage, "電臺創建成功"));
        closeCreateRadioModal();
      })
      .catch(error => {
        console.error('Error creating playlist:', error);
      });
  };

  //生成分享鏈接
  const handleSharePlaylistClick = () => {
    if (songs.length === 0) {
      showAlert(TranslateLanguage(localStorage.userLanguage, "歌單中沒有詩歌，請添加后再分享。"));
    }
    else {
      const urlPrefix = window.location.origin;
      axios.get(`/api/playlists/share/${selectedPlaylist}`)
        .then(response => {
          const data = response.data;
          if (data.shareLink) {
            let shareLink = `${urlPrefix}${data.shareLink}`;
            setShareLink(shareLink);
          } else {
            showAlert(TranslateLanguage(localStorage.userLanguage, "無法生成分享鏈接，可能歌單是私有的。"));
          }
        })
        .catch(error => {
          console.error("生成分享链接时出错:", error);
          showAlert(TranslateLanguage(localStorage.userLanguage, "生成分享鏈接失敗，請點擊“詳情”設置為“公開”！"));
        });
    }
  };

  const extractSongIdFromUrl = (url) => {
    const regex = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|.+?v=))([^?&\/\s]+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const handleSaveAsRadioClick = () => {
    setModalProps({
      userId: user.id,
      playlistId: selectedPlaylist,
      playlisttype: 'radio'
    });
    setshowPlaylistToRadioModal(true);
  };

  const handleDeletePlaylistClick = () => {
    if (window.confirm(TranslateLanguage(localStorage.userLanguage, "確定刪除這個歌單？"))) {
      axios.delete(`/api/playlists/${selectedPlaylist}`)
        .then(response => {
          if (response.status === 200) {
            setPlaylists(playlists.filter(playlist => playlist.id !== selectedPlaylist));
            setPlaylistSongCounts(previousCounts => {
              const nextCounts = { ...previousCounts };
              delete nextCounts[selectedPlaylist];
              return nextCounts;
            });
            showAlert(TranslateLanguage(localStorage.userLanguage, "歌單刪除成功"));
          } else {
            showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
          }
        })
        .catch(error => {
          console.error("删除歌单时出错:", error);
          showAlert(TranslateLanguage(localStorage.userLanguage, "刪除失敗，請重試"));
        });
    }
  };

  const handleGetSongName = async () => {
    const songId = extractSongIdFromUrl(newSongLink);
    if (songId == null) {
      showAlert(TranslateLanguage(localStorage.userLanguage, "輸入鏈接無效"));
      return false;
    }
    try {
      const response = await fetch(`/api/VideoCheck/get-name?videoId=${songId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const result = await response.json();
      if (result && result.title) {
        setNewSongName(result.title);
      } else {
        showAlert(TranslateLanguage(localStorage.userLanguage, "未能获取到有效的标题"));
      }
    } catch (error) {
      showAlert(TranslateLanguage(localStorage.userLanguage, "检测有效视频时发生错误"));
    }
  };

  const resetAndChangePlaylist = (selectedPlaylist) => {
    setSelectedPlaylist(selectedPlaylist);
    const targetPlaylist = playlists.find((playlist) => playlist.id === selectedPlaylist);
    setCurrentPlaylistName(targetPlaylist?.name || '');

    axios.get(`/api/playlists/${selectedPlaylist}/songs`)
      .then(response => {
        const sortedSongs = (response.data || []).sort((a, b) => a.order - b.order);
        setSongs(sortedSongs);
        setInitSong(sortedSongs[0]);
        syncPlaylistSongCount(selectedPlaylist, sortedSongs.length);
        setExpandedPlaylist(selectedPlaylist);
      })
      .catch(error => {
        console.error('Error fetching songs:', error);
      });
  };

  const handleAddSongToPlaylist = async () => {
    const songId = extractSongIdFromUrl(newSongLink);
    if (songId == null) {
      showAlert(TranslateLanguage(localStorage.userLanguage, "輸入鏈接無效"));
      return false;
    }

    if (selectedPlaylist) {
      axios.get(`/api/playlists/${selectedPlaylist}/songs`)
        .then(response => {
          let songs = response.data || [];
          const songExists = songs.some(song => song.resourceId === songId);

          if (!songExists) {
            const requestBody = {
              ResourceId: songId,
              Name: newSongName,
              Link: newSongLink,
              type: '詩歌',
              label: 'v',
              engineId: `USER-songs|${songId}`
            };

            axios.post(`/api/playlists/${selectedPlaylist}/addsongs`, requestBody, {
              headers: { 'Content-Type': 'application/json' }
            })
              .then(response => {
                if (response.status === 200) {
                  showAlert(TranslateLanguage(localStorage.userLanguage, "保存成功"));
                  resetAndChangePlaylist(selectedPlaylist);
                } else {
                  showAlert(TranslateLanguage(localStorage.userLanguage, "保存失敗"));
                }
                setShowAddSongModal(false);
              })
              .catch(error => {
                console.error("Error adding song to playlist:", error);
              });
          } else {
            showAlert(TranslateLanguage(localStorage.userLanguage, "詩歌已在歌單中"));
            setShowAddSongModal(false);
          }
        })
        .catch(error => {
          console.error("Error fetching playlist songs:", error);
        });
    }
  };

  const copyShareLink = () => {
    copyToClipboard(shareLink);
    setShareLink(false);
  };

  const onDragEnd = ({ source, destination }) => {
    if (source && destination) {
      const reorderedSongs = euiDragDropReorder(songs, source.index, destination.index);
      setSongs(reorderedSongs);
      const songOrders = reorderedSongs.map((song, index) => ({
        songId: song.resourceId,
        order: index + 1
      }));

      const payload = {
        playlistId: selectedPlaylist,
        songOrders: songOrders
      };

      axios.post(`/api/playlists/${selectedPlaylist}/reorder`, payload, {
        headers: { 'Content-Type': 'application/json' }
      })
        .then(response => {
          if (response.status !== 200) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          setSongs([...reorderedSongs]);
        })
        .catch(error => {
          console.error('Error saving song order:', error);
        });
    }
  };

  const getFullscreenElement = () => (
    document.fullscreenElement
    || document.webkitFullscreenElement
    || document.mozFullScreenElement
    || document.msFullscreenElement
  );

  const exitPlayerFullscreen = () => {
    if (document.exitFullscreen) return document.exitFullscreen();
    if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
    if (document.mozCancelFullScreen) return document.mozCancelFullScreen();
    if (document.msExitFullscreen) return document.msExitFullscreen();
    return undefined;
  };

  function enterFullscreen() {
    const playerElement = playerShellRef.current;
    if (!playerElement) return;

    if (isIOS) {
      showAlert(TranslateLanguage(localStorage.userLanguage, "在 iOS 設備上，請使用播放器右下角的全屏按鈕進入全屏模式。"));
    } else if (playerElement.requestFullscreen) {
      playerElement.requestFullscreen();
    } else if (playerElement.mozRequestFullScreen) {
      playerElement.mozRequestFullScreen();
    } else if (playerElement.webkitRequestFullscreen) {
      playerElement.webkitRequestFullscreen();
    } else if (playerElement.msRequestFullscreen) {
      playerElement.msRequestFullscreen();
    }
  }

  const togglePanel = () => {
    if (getFullscreenElement()) {
      exitPlayerFullscreen();
    } else {
      enterFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsPlayerFullscreen(getFullscreenElement() === playerShellRef.current);
    };
    const events = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange',
    ];
    events.forEach(eventName => document.addEventListener(eventName, handleFullscreenChange));
    return () => {
      events.forEach(eventName => document.removeEventListener(eventName, handleFullscreenChange));
    };
  }, []);

  useEffect(() => {
    isLoopEnabledRef.current = isLoopEnabled;
  }, [isLoopEnabled]);

  const handleLoopToggle = (e) => {
    setIsLoopEnabled(e.target.checked);
  };

  // =====================
  // ✅ 新增：排序模式 handlers
  // =====================
  const handleMovePlaylist = (playlistId, dir) => {
    setPlaylists(prev => {
      const { pinned, normal } = splitPlaylists(prev);
      const inPinned = pinned.some(p => p.id === playlistId);

      const newPinned = inPinned ? moveWithinGroup(pinned, playlistId, dir) : pinned;
      const newNormal = !inPinned ? moveWithinGroup(normal, playlistId, dir) : normal;

      return mergePlaylists(newPinned, newNormal);
    });
  };

  const handleTogglePlaylistPinned = (playlistId) => {
    setPlaylists(prev => togglePinned(prev, playlistId));
  };

  // ✅ 保存顺序到后端（你后端实现后启用即可）
  // 约定：items 的 order 为“各自分组内的顺序”
  const savePlaylistOrder = async (finalPlaylists) => {
    const { pinned, normal } = splitPlaylists(finalPlaylists);

    const items = [
      ...pinned.map((p, i) => ({ id: p.id, pinned: true, order: i })),
      ...normal.map((p, i) => ({ id: p.id, pinned: false, order: i })),
    ];

    // 你可以把这个接口做成：PUT /api/playlists/order
    // body: { userId, items }
    return axios.put(`/api/playlists/order`, { userId, items }, {
      headers: { 'Content-Type': 'application/json' }
    });
  };

  const handleEnterSortMode = () => {
    setIsSortMode(true);
    // 进入排序模式时收起展开，避免滚动/误触
    setExpandedPlaylist(null);
  };

  const handleDoneSortMode = async () => {
    setIsSavingPlaylistOrder(true);
    try {
      // 前端先乐观更新，后端失败再提示（这里不回滚，避免打断用户；你想回滚我也能加）
      await savePlaylistOrder(playlists);
      showAlert(TranslateLanguage(localStorage.userLanguage, "歌單順序已保存"));
      setIsSortMode(false);
    } catch (e) {
      console.error(e);
      showAlert(TranslateLanguage(localStorage.userLanguage, "保存歌單順序失敗，請稍後重試"));
      // 仍然退出或保留？这里选择保留，避免用户丢操作
      // setIsSortMode(false);
    } finally {
      setIsSavingPlaylistOrder(false);
    }
  };

  const { pinned: pinnedPlaylists, normal: normalPlaylists } = splitPlaylists(playlists);

  const renderPlaylistRow = (playlist, indexInGroup, groupLength) => {
    const isExpanded = expandedPlaylist === playlist.id;
    const songCount = playlistSongCounts[playlist.id] ?? playlist.songCount ?? 0;
    return (
      <div key={playlist.id}>
          <EuiFlexGroup
            alignItems="center"
            gutterSize="s"
            direction="row"
            wrap={false}              // ✅ 1) 外层禁用换行
            responsive={false}        // ✅ 建议一起加，避免断点行为
          >
          <EuiFlexItem grow={1} style={{ minWidth: 0 }}>   {/* ✅ 2) 允许左侧收缩 */}
            <EuiListGroupItem
              className={`playlist-item ${selectedPlaylist === playlist.id ? 'selected-playlist' : ''}`}
              label={
                <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: '8px', maxWidth: '100%' }}>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {TranslateLanguage(localStorage.userLanguage, playlist.name)}
                  </span>
                  <span style={{ color: '#69707d', fontSize: '0.75em', flexShrink: 0, whiteSpace: 'nowrap' }}>
                    {TranslateLanguage(localStorage.userLanguage, `${songCount} 首`)}
                  </span>
                </span>
              }
              onClick={() => handlePlaylistChange(playlist.id)}
              iconType={isExpanded ? 'arrowDown' : 'arrowRight'}
            />
          </EuiFlexItem>

          {/* ✅ 排序模式按钮区 */}
          {isSortMode && (
            <EuiFlexItem grow={false} style={{ flexShrink: 0 }}> {/* ✅ 3) 右侧不被挤压 */}
              <EuiFlexGroup gutterSize="xs" responsive={false} alignItems="center"  wrap={false}>
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType={playlist.pinned ? 'pinFilled' : 'pin'}
                    aria-label={playlist.pinned ? '取消置頂' : '置頂'}
                    onClick={() => handleTogglePlaylistPinned(playlist.id)}
                  />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType="sortUp"
                    aria-label="上移"
                    onClick={() => handleMovePlaylist(playlist.id, -1)}
                    isDisabled={indexInGroup === 0}
                  />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                  <EuiButtonIcon
                    iconType="sortDown"
                    aria-label="下移"
                    onClick={() => handleMovePlaylist(playlist.id, 1)}
                    isDisabled={indexInGroup === groupLength - 1}
                  />
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          )}
        </EuiFlexGroup>

        {/* ✅ 排序模式下不展开歌曲（避免冲突/太长不好操作） */}
        {!isSortMode && expandedPlaylist === playlist.id && (
          <EuiDragDropContext onDragEnd={onDragEnd}>
            <EuiDroppable droppableId="DROPPABLE_AREA" spacing="none">
              {songs.map((song, index) => (
                <EuiDraggable
                  spacing="none"
                  key={song.resourceId}
                  index={index}
                  draggableId={String(song.resourceId)}
                  paddingSize="none"
                  hasBorder={true}
                  withPanel={false}
                >
                  {(provided, state) => (
                    <SongItem
                      song={song}
                      currentSong={currentSong}
                      handleSongClick={handleSongClick}
                      handleDeleteSong={handleDeleteSong}
                      handleMoveSong={handleMoveSong}
                    />
                  )}
                </EuiDraggable>
              ))}
            </EuiDroppable>
          </EuiDragDropContext>
        )}
      </div>
    );
  };

  return (
    <div className="playlistPageShell">
      <div className="appHeaderSticky">
        <EuiHeader className="no-shadow-header">
          <EuiHeaderSection>
          </EuiHeaderSection>
          <EuiHeaderSection side="right">
            <EuiHeaderSectionItem>
              <EuiButtonEmpty
                size="s"
                iconType="home"
                onClick={() => navigate('/')}
                color="text"
                iconSide="left"
                style={{
                  fontWeight: 500,
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  height: '32px',
                  padding: '0 8px',
                }}
              >
                {TranslateLanguage(localStorage.userLanguage, "首頁")}
              </EuiButtonEmpty>
            </EuiHeaderSectionItem>
            <EuiHeaderSectionItem>
              <LanguageToggle />
            </EuiHeaderSectionItem>
            <EuiHeaderSectionItem>
              <TopRightMenu withLanguage="1" />
            </EuiHeaderSectionItem>
          </EuiHeaderSection>
        </EuiHeader>
      </div>

      <EuiFlexGroup 
          className="responsive-flex-group"
          gutterSize="none"
        >
        {/* 左侧播放窗口 */}
        <EuiFlexItem 
          ref={leftpanelRef} 
          // grow={isPanelVisible ? 2 : 3} 
          grow={false}
          className={isPanelVisible ? "left_video_item" : "left_video_item_full"}
          style={{ 
            // position: 'sticky', 
            // top: 0, 
            zIndex: 100, 
            minWidth: 0,
            flexShrink: 0
          }} 
          >
          <EuiPanel
            className="video-player-panel"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              padding: '5px',
            }}
          >
            {showEmpty ? (
              <div>
                <div className="empty-state">
                  <EuiIcon type="iInCircle" size="xl" className="empty-icon" />
                  <div className="empty-text">
                    {TranslateLanguage(localStorage.userLanguage, "沒有歌單或歌單内容爲空")}
                  </div>
                  <div className="empty-subtext">
                    {TranslateLanguage(localStorage.userLanguage, "請點擊「新建歌單」或向當前歌單添加詩歌")}
                  </div>
                </div>
                <div style={{
                  display: 'flex',
                  marginTop: '10px',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  width: '100%'
                }}>
                  <EuiButton
                    size="s"
                    color="danger"
                    iconType="arrowLeft"
                    onClick={() => navigate('/')}
                  >
                    {TranslateLanguage(localStorage.userLanguage, "關閉")}
                  </EuiButton>
                </div>
              </div>
            ) : shouldShowPlayer ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <h3 ref={songtitleRef} style={{ flex: 1, textAlign: 'center', margin: 0 }}>
                        {TranslateLanguage(localStorage.userLanguage, currentSong.name)}
                    </h3>

                    {/* <EuiButtonEmpty iconType={isPanelVisible ? 'arrowRight' : 'arrowLeft'} onClick={togglePanel} style={{ marginLeft: 'auto' }}>
                        {TranslateLanguage(localStorage.userLanguage, '全屏')}
                    </EuiButtonEmpty> */}
                    {!isAndroidApp && (
                      <EuiButtonEmpty
                        iconType={isPlayerFullscreen ? 'arrowLeft' : 'arrowRight'}
                        onClick={togglePanel}
                        style={{ marginLeft: 'auto' }}
                      >
                        {TranslateLanguage(
                          localStorage.userLanguage,
                          isPlayerFullscreen ? '退出全屏' : '全屏'
                        )}
                      </EuiButtonEmpty>
                    )}
                </div>
              </>
            ) : (
              <p>{TranslateLanguage(localStorage.userLanguage, "請點擊歌曲播放")}</p>
            )}

            {/* 播放器壳 */}
            <div style={{ display: shouldShowPlayer ? 'block' : 'none', width: '100%' }}>
              <div ref={playerShellRef} className="playlist-player-shell">
                <div id="youtube-player" className="playlist-player" />
                {isPlayerFullscreen && (
                  <button
                    type="button"
                    className="playlist-fullscreen-exit"
                    onClick={exitPlayerFullscreen}
                    aria-label={TranslateLanguage(localStorage.userLanguage, "退出全屏")}
                  >
                    <span aria-hidden="true">↙</span>
                    <span>{TranslateLanguage(localStorage.userLanguage, "退出全屏")}</span>
                  </button>
                )}
              </div>
              <div style={{
                display: 'flex',
                marginTop: '10px',
                justifyContent: 'space-around',
                alignItems: 'center',
                width: '100%'
              }}>
                <EuiSwitch
                  label={TranslateLanguage(localStorage.userLanguage, "連續播放")}
                  checked={isLoopEnabled}
                  onChange={handleLoopToggle}
                />
                <EuiButton
                  size="s"
                  color="danger"
                  iconType="arrowLeft"
                  onClick={() => navigate('/')}
                >
                  {TranslateLanguage(localStorage.userLanguage, "關閉")}
                </EuiButton>
              </div>
            </div>
          </EuiPanel>
        </EuiFlexItem>

        {/* 右侧歌单及歌曲显示 */}
        {isPanelVisible && (
            <EuiFlexItem
              grow={false}
              className="rigth_song_info playlist-page-right-panel"
              style={{
                minWidth: 0,
                minHeight: 0,
                overflowX: 'hidden',
                overflowY: 'auto'
              }}
            >
            <EuiPanel
              className="playlist-list-panel playlist-page-list-panel"
              hasShadow={false}
              hasBorder={false}
              style={{
                width: '100%',
                height: 'auto',
                minHeight: '100%',
                maxHeight: 'none',
                textAlign: 'center',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'visible'
              }}
            >
              {/* 顶部Logo和标题部分 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  marginBottom: '10px',
                  width: '100%'
                }}
                onClick={() => navigate('/')}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <img src={logosmall} alt="Logo" style={{ width: '50px', height: '50px', marginBottom: '10px' }} />
                  <h2 style={{ margin: 10, textAlign: 'center' }}>
                    <span>{user ? `${TranslateLanguage(localStorage.userLanguage, user.username)}的歌單` : '我的歌單'}</span>
                    <span style={{ marginLeft: '8px', color: '#69707d', fontSize: '0.5em', fontWeight: 400, whiteSpace: 'nowrap' }}>
                      {playlists.length}{TranslateLanguage(localStorage.userLanguage, "個")}
                    </span>
                  </h2>
                </div>
              </div>

              {/* 歌单和歌曲列表部分 */}
              <div style={{ width: '100%' }}>
                <EuiListGroup flush>
                    {/* 置顶歌单 */}
                    {pinnedPlaylists.map((p, idx) =>
                        renderPlaylistRow(p, idx, pinnedPlaylists.length)
                    )}

                    {/* 中间分隔线：只有同时存在置顶 & 普通时才显示 */}
                    {pinnedPlaylists.length > 0 && normalPlaylists.length > 0 && (
                        <div
                        style={{
                            margin: '8px 12px',
                            borderTop: '2px solid #D3DAE6'
                        }}
                        />
                    )}

                    {/* 普通歌单 */}
                    {normalPlaylists.map((p, idx) =>
                        renderPlaylistRow(p, idx, normalPlaylists.length)
                    )}
                </EuiListGroup>

                <div style={{ width: '100%', padding: '5px', display: 'flex', justifyContent: 'space-evenly' }}>
                  {selectedPlaylist && (
                    <>
                      <EuiButtonEmpty iconType="advancedSettingsApp" size="s" onClick={handleEditClick} isDisabled={isSortMode}>
                        {TranslateLanguage(localStorage.userLanguage, "歌單詳情")}
                      </EuiButtonEmpty>
                      <EuiButtonEmpty iconType="share" size="s" onClick={handleSharePlaylistClick} isDisabled={isSortMode}>
                        {TranslateLanguage(localStorage.userLanguage, "分享歌單")}
                      </EuiButtonEmpty>
                    </>
                  )}
                </div>

                <div style={{ width: '100%', padding: '5px', display: 'flex', justifyContent: 'space-evenly' }}>
                  {selectedPlaylist && (
                    <>
                      <EuiButtonEmpty iconType="trash" size="s" onClick={handleDeletePlaylistClick} isDisabled={isSortMode}>
                        {TranslateLanguage(localStorage.userLanguage, "刪除歌單")}
                      </EuiButtonEmpty>
                    </>
                  )}
                  <EuiButtonEmpty iconType="listAdd" size="s" onClick={openCreatePlaylistModal} isDisabled={isSortMode}>
                    {TranslateLanguage(localStorage.userLanguage, "新建歌單")}
                  </EuiButtonEmpty>
                </div>

                <div style={{ width: '100%', padding: '5px', display: 'flex', justifyContent: 'space-evenly' }}>
                  {selectedPlaylist && (
                    <>
                      <EuiButtonEmpty iconType="plusInSquare" size="s" onClick={openAddSongModal} isDisabled={isSortMode}>
                        {TranslateLanguage(localStorage.userLanguage, "加入詩歌")}
                      </EuiButtonEmpty>

                      {/* ✅ 歌单排序按钮：放在“加入诗歌”右侧 */}
                      {!isSortMode ? (
                        <EuiButtonEmpty iconType="sortable" size="s" onClick={handleEnterSortMode}>
                          {TranslateLanguage(localStorage.userLanguage, "歌單排序")}
                        </EuiButtonEmpty>
                      ) : (
                        <>
                          <EuiButtonEmpty
                            iconType="check"
                            size="s"
                            onClick={handleDoneSortMode}
                            isDisabled={isSavingPlaylistOrder}
                          >
                            {TranslateLanguage(localStorage.userLanguage, "完成")}
                          </EuiButtonEmpty>
                          <EuiButtonEmpty
                            iconType="cross"
                            size="s"
                            color="danger"
                            onClick={() => { setIsSortMode(false); }}
                            isDisabled={isSavingPlaylistOrder}
                          >
                            {TranslateLanguage(localStorage.userLanguage, "取消")}
                          </EuiButtonEmpty>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </EuiPanel>
          </EuiFlexItem>
        )}

        {/* 分享链接 Modal */}
        {shareLink && (
          <EuiModal
            onClose={() => setShareLink(false)}
            style={{
              maxWidth: '90%',
              height: '90%',
              minHeight: '50vh',
              margin: 'auto'
            }}
          >
            <EuiModalHeader>
              <h2 style={{ textAlign: 'center', width: '100%' }}>
                {TranslateLanguage(localStorage.userLanguage, "分享鏈接")}
              </h2>
            </EuiModalHeader>

            <EuiModalBody style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
              <div style={{ overflowX: 'auto', wordBreak: 'break-all', maxWidth: '100%' }}>
                <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{shareLink}</p>
              </div>
            </EuiModalBody>

            <EuiModalFooter style={{ display: 'flex' }}>
              <EuiButton fill onClick={() => copyShareLink(shareLink)}>
                {TranslateLanguage(localStorage.userLanguage, "複製鏈接")}
              </EuiButton>
              <EuiButton onClick={() => setShareLink(false)} color="danger">
                {TranslateLanguage(localStorage.userLanguage, "關閉")}
              </EuiButton>
            </EuiModalFooter>
          </EuiModal>
        )}

        {/* 编辑歌单 Modal */}
        {isEditModalVisible && (
          <EuiModal 
            onClose={() => setIsEditModalVisible(false)}
            style={{
              maxWidth: '90%',
              height: '90%',
              minHeight: '50vh',
              margin: 'auto'
            }}
          >
            <EuiModalHeader>
              <h2>{TranslateLanguage(localStorage.userLanguage, "歌單詳情")}</h2>
            </EuiModalHeader>
            <EuiModalBody>
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "歌單名稱")}
                value={TranslateLanguage(localStorage.userLanguage, newPlaylistName)}
                onChange={e => setNewPlaylistName(e.target.value)}
                required
                aria-label="歌單名稱"
                isInvalid={!newPlaylistName.trim()}
              />
              <EuiSelect
                options={[
                  { value: 'public', text: TranslateLanguage(localStorage.userLanguage, "公開") },
                  { value: 'private', text: TranslateLanguage(localStorage.userLanguage, "私有") },
                  { value: 'shareable', text: TranslateLanguage(localStorage.userLanguage, "可分享但不加入搜索列表") }
                ]}
                value={newPlaylistVisibility}
                onChange={(e) => setNewPlaylistVisibility(e.target.value)}
              />
              <EuiTextArea
                placeholder={TranslateLanguage(localStorage.userLanguage, "歌單描述")}
                value={newPlaylistDescription}
                onChange={(e) => setNewPlaylistDescription(e.target.value)}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "標籤(用逗號分隔)")}
                value={newPlaylistTags}
                onChange={(e) => setNewPlaylistTags(e.target.value)}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "分類")}
                value={newPlaylistCategory}
                onChange={(e) => setNewPlaylistCategory(e.target.value)}
              />
            </EuiModalBody>
            <EuiModalFooter>
              <EuiButton
                onClick={() => {
                  if (newPlaylistName.trim()) {
                    handleSaveChanges();
                  } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "歌單名稱為必填項"));
                  }
                }}
                fill
              >
                {TranslateLanguage(localStorage.userLanguage, "保存更改")}
              </EuiButton>
              <EuiButton onClick={() => setIsEditModalVisible(false)} color="danger">
                {TranslateLanguage(localStorage.userLanguage, "取消")}
              </EuiButton>
            </EuiModalFooter>
          </EuiModal>
        )}

        {/* 新建歌单 Modal */}
        {showCreateModal && (
          <EuiModal 
            onClose={closeCreatePlaylistModal}
            style={{
              maxWidth: '90%',
              height: '90%',
              minHeight: '50vh',
              margin: 'auto'
            }}
          >
            <EuiModalHeader>
              <h2>{TranslateLanguage(localStorage.userLanguage, "創建新的歌單")}</h2>
            </EuiModalHeader>
            <EuiModalBody>
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "歌單名稱")}
                value={newPlaylistName}
                onChange={e => setNewPlaylistName(e.target.value)}
                required
                aria-label="歌單名稱"
                isInvalid={!newPlaylistName.trim()}
              />
              <EuiSelect
                options={[
                  { value: 'public', text: TranslateLanguage(localStorage.userLanguage, "公開") },
                  { value: 'private', text: TranslateLanguage(localStorage.userLanguage, "私有") },
                  { value: 'shareable', text: TranslateLanguage(localStorage.userLanguage, "可分享但不加入搜索列表") }
                ]}
                value={newPlaylistVisibility}
                onChange={e => setNewPlaylistVisibility(e.target.value)}
              />
              <EuiTextArea
                placeholder={TranslateLanguage(localStorage.userLanguage, "歌單描述")}
                value={newPlaylistDescription}
                onChange={(e) => setNewPlaylistDescription(e.target.value)}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "標籤(用逗號分隔)")}
                value={newPlaylistTags}
                onChange={(e) => setNewPlaylistTags(e.target.value)}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "分類")}
                value={newPlaylistCategory}
                onChange={(e) => setNewPlaylistCategory(e.target.value)}
              />
            </EuiModalBody>
            <EuiModalFooter>
              <EuiButton
                onClick={() => {
                  if (newPlaylistName.trim()) {
                    handleCreatePlaylist();
                  } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "歌單名稱為必填項"));
                  }
                }}
                fill
              >
                {TranslateLanguage(localStorage.userLanguage, "創建")}
              </EuiButton>
              <EuiButton onClick={closeCreatePlaylistModal} color="danger">
                {TranslateLanguage(localStorage.userLanguage, "取消")}
              </EuiButton>
            </EuiModalFooter>
          </EuiModal>
        )}

        {/* RadioModal */}
        {showPlaylistToRadioModal && (
          <RadioModal
            userId={modalProps.userId}
            playlistId={modalProps.playlistId}
            playlisttype={modalProps.playlisttype}
            closeModal={() => setshowPlaylistToRadioModal(false)}
          />
        )}

        {/* 加入詩歌 Modal */}
        {showAddSongModal && (
          <EuiModal 
            onClose={closeAddSongModal}
            style={{
              width: 'min(680px, 94vw)',
              maxWidth: '94vw',
              maxHeight: '90vh',
              margin: 'auto'
            }}  
          >
            <EuiModalHeader>
              <h2>{TranslateLanguage(localStorage.userLanguage, "添加詩歌到歌單《" + currentPlaylistName + "》")}</h2>
            </EuiModalHeader>
            <EuiModalBody>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }} role="group" aria-label={TranslateLanguage(localStorage.userLanguage, '添加方式')}>
                <EuiButton size="s" fill={addSongMode === 'single'} onClick={() => setAddSongMode('single')}>
                  {TranslateLanguage(localStorage.userLanguage, '單首詩歌')}
                </EuiButton>
                <EuiButton size="s" fill={addSongMode === 'playlist'} onClick={() => setAddSongMode('playlist')}>
                  {TranslateLanguage(localStorage.userLanguage, 'YouTube 播放列表')}
                </EuiButton>
              </div>
              {addSongMode === 'single' ? <>
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "詩歌Youtube鏈接")}
                value={newSongLink}
                onChange={e => setNewSongLink(e.target.value)}
                required
                aria-label="詩歌Youtube鏈接"
                isInvalid={!newSongLink.trim()}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "詩歌名稱")}
                value={newSongName}
                onChange={e => setNewSongName(e.target.value)}
                required
                aria-label="詩歌名稱"
                isInvalid={!newSongName.trim()}
              />
              </> : <YouTubePlaylistImport playlistId={selectedPlaylist} existingSongs={songs}
                onImported={({ added, skipped }) => {
                  showAlert(TranslateLanguage(localStorage.userLanguage, `已加入 ${added} 首詩歌${skipped ? `，略過 ${skipped} 首重複詩歌` : ''}。`));
                  resetAndChangePlaylist(selectedPlaylist);
                  setShowAddSongModal(false);
                }} />}
            </EuiModalBody>
            <EuiModalFooter>
              {addSongMode === 'single' && <>
              <EuiButton
                onClick={() => {
                  if (newSongLink.trim()) {
                    handleGetSongName();
                  } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "請先輸入詩歌鏈接"));
                  }
                }}
                fill
              >
                {TranslateLanguage(localStorage.userLanguage, "獲取歌名")}
              </EuiButton>
              <EuiButton
                onClick={() => {
                  if ((newSongLink.trim()) && (newSongName.trim())) {
                    handleAddSongToPlaylist();
                  } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "詩歌鏈接和名稱為必填項"));
                  }
                }}
                fill
              >
                {TranslateLanguage(localStorage.userLanguage, "添加")}
              </EuiButton>
              </>}
              <EuiButton onClick={closeAddSongModal} color="danger">
                {TranslateLanguage(localStorage.userLanguage, "取消")}
              </EuiButton>
            </EuiModalFooter>
          </EuiModal>
        )}

        {/* PlaylistModal */}
        {showPlaylistModal && (
          <PlaylistModal
            userId={playlistmodalProps.userId}
            songId={playlistmodalProps.songId}
            videoURL={playlistmodalProps.videoURL}
            title={playlistmodalProps.title}
            type={playlistmodalProps.type}
            engineId={playlistmodalProps.engineId}
            label={playlistmodalProps.label}
            playlisttype={playlistmodalProps.playlisttype}
            closeModal={() => setShowModal(false)}
            onSaveSuccess={playlistmodalProps.onSaveSuccess}
          />
        )}

        {/* 新建電臺 Modal */}
        {showCreateRadioModal && (
          <EuiModal 
            onClose={closeCreateRadioModal}
            style={{
              maxWidth: '90%',
              height: '90%',
              minHeight: '50vh',
              margin: 'auto'
            }}
          >
            <EuiModalHeader>
              <h2>{TranslateLanguage(localStorage.userLanguage, "創建新的電臺")}</h2>
            </EuiModalHeader>
            <EuiModalBody>
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "電臺名稱")}
                value={newPlaylistName}
                onChange={e => setNewPlaylistName(e.target.value)}
                required
                aria-label="電臺名稱"
                isInvalid={!newPlaylistName.trim()}
              />
              <EuiSelect
                options={[
                  { value: 'public', text: TranslateLanguage(localStorage.userLanguage, "公開") },
                  { value: 'private', text: TranslateLanguage(localStorage.userLanguage, "私有") },
                  { value: 'shareable', text: TranslateLanguage(localStorage.userLanguage, "可分享但不加入搜索列表") }
                ]}
                value={newPlaylistVisibility}
                onChange={e => setNewPlaylistVisibility(e.target.value)}
              />
              <EuiTextArea
                placeholder={TranslateLanguage(localStorage.userLanguage, "電臺描述")}
                value={newPlaylistDescription}
                onChange={(e) => setNewPlaylistDescription(e.target.value)}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "標籤(用逗號分隔)")}
                value={newPlaylistTags}
                onChange={(e) => setNewPlaylistTags(e.target.value)}
              />
              <EuiFieldText
                placeholder={TranslateLanguage(localStorage.userLanguage, "分類")}
                value={newPlaylistCategory}
                onChange={(e) => setNewPlaylistCategory(e.target.value)}
              />
            </EuiModalBody>
            <EuiModalFooter>
              <EuiButton
                onClick={() => {
                  if (newPlaylistName.trim()) {
                    handleCreateRadio();
                  } else {
                    showAlert(TranslateLanguage(localStorage.userLanguage, "電臺名稱為必填項"));
                  }
                }}
                fill
              >
                {TranslateLanguage(localStorage.userLanguage, "創建")}
              </EuiButton>
              <EuiButton onClick={closeCreateRadioModal} color="danger">
                {TranslateLanguage(localStorage.userLanguage, "取消")}
              </EuiButton>
            </EuiModalFooter>
          </EuiModal>
        )}
      </EuiFlexGroup>
    </div>
  );
}

export default PlaylistPageWithPlayer;
